<div  class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0 flex-expandir" [ngClass.gt-sm]="'mb-0  p-0'">

  <div *ngIf="selectionService.isLoading" class="m-auto">
    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </div>

  <app-employee-list class="flex-expandir" *ngIf="sharedService.selectedSelectionTabId === 1 &&  permissionList.includes('201')"></app-employee-list>
  <app-leave-list class="flex-expandir" *ngIf="sharedService.selectedSelectionTabId === 2 &&  permissionList.includes('202')"></app-leave-list>
  <app-actuation-list class="flex-expandir" *ngIf="sharedService.selectedSelectionTabId === 3 &&  permissionList.includes('203')"></app-actuation-list>
  <app-tarea-list  class="flex-expandir" *ngIf="sharedService.selectedSelectionTabId === 5 &&  permissionList.includes('204')"></app-tarea-list>

</div>